// administratorConfig.ts
import { FieldTypeEnum, FormField } from '../../Form/DynamicForm'
import { TableColumn, enumTypeColumn } from '../../Table'

export const columnsSuperAdmin: TableColumn[] = [
  {
    title: 'Foto',
    dataIndex: 'photo',
    key: 'photo',
    type: enumTypeColumn.photo
  },
  {
    title: 'Nombre',
    dataIndex: 'name',
    key: 'name',
    type: enumTypeColumn.string
  },
  {
    title: 'Apellido',
    dataIndex: 'lastName',
    key: 'lastName',
    type: enumTypeColumn.string
  },
  {
    title: 'User',
    dataIndex: 'userName',
    key: 'userName',
    type: enumTypeColumn.string
  },
  {
    title: 'Número',
    dataIndex: 'number',
    key: 'number',
    type: enumTypeColumn.string
  },
  {
    title: 'Creado en',
    dataIndex: 'createdAt',
    key: 'createdAt',
    type: enumTypeColumn.date
  }
]

export const superAdminFormConfig: FormField[] = [
  { type: FieldTypeEnum.text, label: 'Nombre', name: 'name' },
  { type: FieldTypeEnum.text, label: 'Apellido', name: 'lastName' },
  { type: FieldTypeEnum.text, label: 'User', name: 'userName' },
  { type: FieldTypeEnum.phone, label: 'Número', name: 'number' },
  { type: FieldTypeEnum.text, label: 'Contraseña', name: 'password' },
  { type: FieldTypeEnum.image, label: 'Foto', name: 'photo' }
]
